import { graphql, type ResultOf } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';

export const topicListItemFragment = graphql(
  `
    fragment TopicListItem on Folder {
      __typename
      id
      name
      position
      usage
      libraryFolder {
        ...Folder
      }
      topicStatistics {
        linkedItemsTotal
      }
      topicCourses {
        id
        __typename
        name
        shortName
        foregroundColor
        backgroundColor
      }
      createdAt
      permissions {
        canDeleteTopicFromOwnLibrary
        canDuplicateTopic
      }
    }
  `,
  [folderFragment],
);

type TopicListItemFragment = ResultOf<typeof topicListItemFragment>;

export type TopicListItem = Omit<
  TopicListItemFragment,
  '__typename' | 'topicStatistics' | 'topicCourses' | 'createdAt'
> & {
  itemCount: number;
  courses: NonNullable<TopicListItemFragment['topicCourses']>;
  permissions: NonNullable<TopicListItemFragment['permissions']>;
  createdAt: Date;
};

export function convertTopicListItemFragment(
  fragment: TopicListItemFragment,
): TopicListItem {
  const permissions = fragment.permissions;
  if (!permissions) {
    throw new Error(
      `Received TopicListItem without Permissions. ${JSON.stringify(fragment)}`,
    );
  }
  return {
    ...fragment,
    itemCount: fragment.topicStatistics?.linkedItemsTotal ?? 0,
    courses: fragment.topicCourses ?? [],
    createdAt: new Date(fragment.createdAt),
    permissions,
  };
}
